interface IHeaderProps {
  title?: string
  description?: string
}
export default function Header({
  title = 'Header',
  description = 'Description'
}: IHeaderProps) {
  return (
    <div className="flex flex-col gap-2 px-6 py-5 border-b-2">
      <h2 className="font-semibold">{title}</h2>
      <p className="text-sm">{description}</p>
    </div>
  )
}
